import axios from 'axios';
import { getUserById } from './db';

/**
 * Authenticate a user by identity_number.
 * Tries the Express backend first; falls back to local db.js when the
 * server is not reachable (e.g. during frontend-only development).
 */
export async function loginUser(identity_number) {
  const id = String(identity_number).trim();
  if (!id) return { user: null, error: 'رقم الهوية مطلوب' };

  try {
    const { data } = await axios.post('/api/auth/login', { identity_number: id }, { timeout: 4000 });
    return { user: data.user, error: null };
  } catch (err) {
    // Backend unavailable → fall back to in-memory db.js
    if (!err.response) {
      const user = getUserById(id);
      if (user) return { user, error: null };
      return { user: null, error: 'رقم الهوية غير موجود' };
    }
    const msg = err.response?.data?.error || 'حدث خطأ، يرجى المحاولة لاحقاً';
    return { user: null, error: msg };
  }
}
